import React from "react";
import { technologies } from "../constants";

/* ═══════════════════════════════════════════════════════════
   TECH — Infinite Marquee
   Gold-tinted tech icons · seamless loop · pause on hover
   ═══════════════════════════════════════════════════════════ */

const Tech = () => {
  // Duplicate the list for seamless marquee loop
  const doubled = [...technologies, ...technologies];

  return (
    <div className="lux-container">
      <div className="max-w-3xl mb-16">
        <p className="lux-eyebrow mb-6">Capabilities</p>
        <h2 className="lux-heading">
          <span className="reveal-line">
            <span>Technologies</span>
          </span>
        </h2>
      </div>

      <div
        className="lux-marquee reveal-fade"
        style={{
          maskImage:
            "linear-gradient(90deg, transparent, black 10%, black 90%, transparent)",
          WebkitMaskImage:
            "linear-gradient(90deg, transparent, black 10%, black 90%, transparent)",
        }}
      >
        <div className="lux-marquee-track">
          {doubled.map((tech, i) => (
            <div
              key={`${tech.name}-${i}`}
              className="flex items-center gap-4 px-6 py-4"
            >
              <img
                src={tech.icon}
                alt={tech.name}
                className="w-10 h-10 object-contain opacity-60 hover:opacity-100 transition-opacity duration-500"
                loading="lazy"
              />
              <span className="font-grotesk text-sm tracking-[0.2em] uppercase text-silver-400 whitespace-nowrap">
                {tech.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Tech;